import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

interface VitalSignsO2SectionProps {
    children: React.ReactNode;
}

export const VitalSignsO2Section = ({ children }: VitalSignsO2SectionProps) => {
    const { t } = useTranslate();

    return (
        <Grid
            container
            alignItems="center"
            sx={{ borderBottom: "1px solid #E0E0E0", py: 1.5, width: "100%" }}
        >
            {/* Labels */}
            <Grid xs={12} sm={4} md={4} container>
                <Grid xs={4}>
                    <ByzMuiTypography sx={{ marginLeft: "10px" }}>
                        {t("vital-signs.is-o2-being-received")}
                    </ByzMuiTypography>
                </Grid>
                <Grid xs={4}>
                    <ByzMuiTypography>{t("vital-signs.o2-amount")}</ByzMuiTypography>
                </Grid>
                <Grid xs={4}>
                    <ByzMuiTypography>{t("vital-signs.o2-unit")}</ByzMuiTypography>
                </Grid>
            </Grid>

            {/* Inputs */}
            <Grid xs={12} sm={8} md={8} container spacing={2}>
                {children}
            </Grid>
        </Grid>
    );
};
